import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import AddGallery from './AddGallery';
import Swal from 'sweetalert2';
import Input from '../../components/Input';

const Gallery = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [addTeacherModal, setAddTeacherModal] = useState(false);
  const [cnicModal, setCnicModal] = useState(false);
  const [selectedCnicImage, setSelectedCnicImage] = useState([]);
  console.log(selectedCnicImage);

  const galleryFetch = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    setLoading(true);
    fetch('https://quran-backend-theta.vercel.app/v1/admin/gallery-images', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log(data);

        setTeachers(data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    galleryFetch();
  }, []);

  const handleCnicClick = (cnicImage) => {
    console.log(cnicImage);

    setSelectedCnicImage(cnicImage);
    setCnicModal(true);
  };

  const handleDeleteClick = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this Gallery!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');

        const requestOptions = {
          method: 'DELETE',
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(
          `https://quran-backend-theta.vercel.app/v1/admin/gallery-images/${id}`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            let data = JSON.parse(result);

            if (data.success === true) {
              Swal.fire({
                title: 'Deleted!',
                text: 'Your gallery has been deleted.',
                icon: 'success',
                confirmButtonText: 'OK'
              }).then(() => {
                galleryFetch();
              });
            }
          })
          .catch((error) => {
            console.error(error);
            Swal.fire({
              title: 'Error!',
              text: 'An error occurred while deleting the note.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
          });
      }
    });
  };

  return (
    <Wrapper
      
    >
      {/* Modal for adding teacher */}
      <AddGallery setIsModalOpen={setAddTeacherModal} isModalOpen={addTeacherModal} />

      <div className="flex justify-between items-center ">
        <div>
          <h2 className="main_title ">Gallery</h2>
          <p className="text-[#1C1D1D]">Here overview of the Gallery</p>
        </div>
        <div className="cursor-pointer">
          <img
            onClick={() => setAddTeacherModal(true)} // Open the Add Teacher modal
            src={require('../../assets/image/add.png')}
            alt=""
          />
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center">
          <p>Loading...</p>
        </div>
      ) : (
        <section className="mb-20 mt-7">
          <div className="rounded-lg overflow-x-auto">
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead className="">
                        <tr className="rounded-lg whitespace-nowrap">
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            ID
                          </th>

                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Image
                          </th>

                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Active
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {teachers?.map((teacher, index) => (
                          <tr key={teacher?._id} className="bg-white shadow-lg mt-6 rounded-lg">
                            <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full">
                                {index + 1}
                              </span>
                            </td>

                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span
                                className="bg-green-200 text-base text-secondary py-1 px-2.5 leading-none whitespace-nowrap rounded-full cursor-pointer"
                                onClick={() => handleCnicClick(teacher)}
                              >
                                View Gallery
                              </span>
                            </td>

                            <td className="align-middle bg-white  text-sm font-normal px-6 whitespace-nowrap ">
                              <img
                                className="cursor-pointer mx-auto"
                                src={require('../../assets/image/del.png')}
                                alt="Delete"
                                onClick={() => handleDeleteClick(teacher?._id)}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Modal to show CNIC image */}
      {cnicModal && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-4 rounded-lg shadow-xl relative max-w-sm w-full">
              {selectedCnicImage && (
                <img src={selectedCnicImage?.imageUrl} alt="CNIC" className="w-full h-auto mb-4" />
              )}

              <div className="flex justify-end ">
                <button
                  onClick={() => setCnicModal(false)}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </Wrapper>
  );
};

export default Gallery;
